let config = {};

config.baseURL = 'https://api.intermedica.innovareti.com.br/api/v1/';
config.normalURL = 'https://api.intermedica.innovareti.com.br/';
config.envType = 'production';
config.applicationName = 'Gestão de Frotas - NotreDame Intermédica'
config.footerName = 'Gestão de Frotas - NotreDame Intermédica';

export default config




// WEBPACK FOOTER //
// ./src/config/prod.js